import { msg } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { MediaManagerTemplate } from 'modules/core/domain/interfaces/supabase/media-manager/entity';
import { useUpdateMediaManagerTemplateMutation } from 'modules/manager/store/media-manager-api';
import React, { useCallback } from 'react';
import UDCheckbox from 'ud-form/components/checkbox/component';
import UDText from 'ud-ui/components/text';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';

interface DefaultForKindCheckboxProps {
  template: MediaManagerTemplate | null | undefined;
}

const DefaultForKindCheckbox: React.FC<DefaultForKindCheckboxProps> = ({ template }) => {
  const toastApiError = useToastApiError();
  const [updateTemplate, { isLoading }] = useUpdateMediaManagerTemplateMutation();
  const canEdit = template != null && template.tournamentId != null;

  const onChange = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!template || !canEdit) return;
      try {
        await updateTemplate({ id: template.id, isDefaultForKind: event.target.checked }).unwrap();
      } catch (error) {
        console.error('Failed to update default-for-kind flag:', error);
        toastApiError(error, msg`Не удалось сохранить флаг по умолчанию`);
      }
    },
    [template, canEdit, updateTemplate, toastApiError],
  );

  if (!template || !canEdit) return null;

  return (
    <label className="flex items-center justify-between gap-3" data-testid="default-for-kind-checkbox">
      <UDText type="subhead">
        <Trans>По умолчанию для этого типа</Trans>
      </UDText>
      <UDCheckbox checked={template.isDefaultForKind} disabled={isLoading} onChange={onChange} data-testid="default-for-kind-input" />
    </label>
  );
};

export default DefaultForKindCheckbox;
